<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <div class="mt-6">
        <v-slide-x-reverse-transition>
          <v-alert type="success" class="alert" v-if="alert_success === true">อัพเดทข้อมูลเรียบร้อย !</v-alert>
        </v-slide-x-reverse-transition>
        <v-card elevation="6" class="pa-2">
          <div class="pa-4">
            <span style="font-size: 24px">ตารางสรุปยอดการนับสต๊อก</span>
          </div>
          <div class="pa-2">
            <v-card-title>
              <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="detailHeader" :items="data_list" :footer-props="footer_Props" :items-per-page.sync="item_page" :search="search" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td class="hidden_line">
                     <div v-if="dataDetail.item.product_code != null">{{ dataDetail.item.product_code }}</div>
                     <div v-else>-</div>
                  </td>
                  <td class="hidden_line"> {{ dataDetail.item.product_name }}</td>
                  <td class="text-center hidden_line"> {{ dataDetail.item.qty_sml }}</td>
                  <td class="hidden_line"> {{ dataDetail.item.unit_name }}</td>
                  <td class="text-center hidden_line">
                    <div v-if="dataDetail.item.count_qty !== 0">{{ dataDetail.item.count_qty }}</div>
                    <div v-else>-</div>
                  </td>
                  <td class="text-center hidden_line">
                    <div v-if="dataDetail.item.diff_qty < 0" style="color: red">{{ dataDetail.item.diff_qty }}</div>
                    <div v-if="dataDetail.item.diff_qty == 0">0</div>
                    <div v-if="dataDetail.item.diff_qty > 0" style="color: #86bc3a">+{{ dataDetail.item.diff_qty }}</div>
                  </td>
                  <td class="hidden_line">
                    <div class="mt-3 mr-1">
<!--                      <v-text-field color="#86bc3a" type="text" class="ma-2" label="อัพเดทสต๊อก" @input="diff_after_change(dataDetail.item.id, dataDetail.item.stock_id, dataDetail.item.confirm_count)" v-model="dataDetail.item.confirm_count" hide-details="auto" outlined></v-text-field>-->
                      <v-text-field color="#86bc3a" type="text" class="ma-2" label="อัพเดทสต๊อก" v-model="dataDetail.item.confirm_count" hide-details="auto" outlined></v-text-field>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <div class="pa-3 text-right">
            <v-btn x-large @click="save_data" class="grad-success-bg white--text ma-2" style="font-size: 20px" :disabled="btn_disabled">บันทึกการนับสต๊อก</v-btn>
          </div>
          <v-overlay :value="overlay" class="z_index">
            <div class="text-center">
              <v-progress-circular
                  indeterminate
                  size="70"
                  width="7"
                  color="#86bc3a"
              ></v-progress-circular>
              <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
            </div>
          </v-overlay>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
import {onlyForNumber} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "Count_Close",
  data() {
    return {
      loading_page: false,
      btn_disabled: false,
      alert_success: false,
      search: null,
      warning: null,
      overlay: false,
      sortBy: 'diff_qty',
      // sortBy: '',
      // sortDesc: false,
      sortDesc: true,
      item_page: -1,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      detailHeader: [
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '300px',
        },
        {
          text: 'จำนวนคงคลัง',
          value: 'qty_sml',
          fixed: true,
          width: '180px',
        },
        {
          text: 'หน่วย',
          value: 'unit_name',
          fixed: true,
          width: '100px',
        },
        {
          text: 'นับได้',
          value: 'count_qty',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ส่วนต่างก่อนปรับ',
          value: 'diff_qty',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ส่วนต่างหลังปรับ',
          value: 'confirm_count',
          fixed: true,
          width: '250px',
        },
      ],
      data_list: []
    }
  },
  methods: {
    isOnlyNumber: function(evt) {
      return onlyForNumber(evt)
    },
    get_stock_detail() {
      this.loading_page = true
      let count_stock_id = this.$route.params.id
      HTTP.post('/stocks/getproductinstock', {
        stock_id: count_stock_id
      }).then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              res.data.object.forEach((data) => {
                this.data_list.push({
                  id: data.id,
                  stock_id: count_stock_id,
                  product_code: data.product_code,
                  product_barcode: data.product_barcode,
                  product_name: data.product_name,
                  unit_name: data.unit_name,
                  qty_sml: data.qty_sml,
                  user_id: data.user_id,
                  count_qty: data.count_qty,
                  diff_qty: data.diff_qty,
                  // confirm_count: data.diff_qty_after,
                  confirm_count: null,
                })
              })
            }
          })
    },
    diff_after_change(id, stock_id, confirm_count) {
      setTimeout(() => {
        HTTP.post('/stocks/stocksavebyone/' + id, {
          qty_sml: confirm_count,
        }).then((res) => {
              if (res.data.success === true) {
                this.alert_success = true
                setTimeout(() => this.alert_success = false, 1500)
              }
            })
      }, 3000)
    },
    save_data() {
      this.overlay = true
      this.btn_disabled = true
      let count_stock_id = this.$route.params.id
      HTTP.post('/stocks/stocksave', {
        stock_id: count_stock_id,
        user_confirm_id: this.$store.state.userDetail.id,
        data_list: this.data_list
      }).then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          Swal.fire({
            title: 'บันทึกข้อมูลเรียบร้อย',
            icon: 'success',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then((res) => {
            if (res.isConfirmed) {
              this.btn_disabled = false
              this.$router.push('/count_stock/historylist')
            }
            else {
              this.btn_disabled = false
              this.$router.push('/count_stock/historylist')
            }
          });
        }
      })
    },
  },
  beforeMount() {
    this.get_stock_detail();
  },
  created() {
    window.addEventListener('beforeunload', function (event) {
      event.preventDefault();
      event.returnValue = '';
    })
  },
}
</script>

<style scoped>

</style>
